<nz-form-control>
  <ng-content></ng-content>
</nz-form-control>
<div *ngIf="errorMessage as config" class="error-message" @fadeAnimation>
  {{ config.key | translate: config.options }}
</div>
